import { render } from "./SupplyAutoReading.vue?vue&type=template&id=d0ba98ba&scoped=true"
import script from "./SupplyAutoReading.vue?vue&type=script&lang=js"
export * from "./SupplyAutoReading.vue?vue&type=script&lang=js"

import "./SupplyAutoReading.vue?vue&type=style&index=0&id=d0ba98ba&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ba98ba"]])

export default __exports__